<template>
  <v-navigation-drawer
    v-model="showDrawer"
    app
    :disable-resize-watcher="!autoDisplay"
  >
    <v-list v-if="user" :style="{ paddingTop: `${topMargin}px`}">
      <v-list-item v-if="user.persional_page">
        <v-list-item-avatar>
          <v-img :src="user.persional_page"></v-img>
        </v-list-item-avatar>
      </v-list-item>
      <v-list-item link>
        <v-list-item-content>
          <v-list-item-title>{{user.name}}</v-list-item-title>
          <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list nav dense :style="{ paddingTop: `${user ? 0 : topMargin}px`}">
      <template v-for="item in items">
        <v-list-item
          v-if="item.subitems.length === 0"
          :key="item.key"
          :to="item.to"
          :href="item.href"
          @click="onItemClick(item, $event)"
        >
          <v-list-item-icon v-if="item.icon">
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{$t(item.title)}}</v-list-item-title>
        </v-list-item>

        <v-list-group v-if="item.subitems.length > 0" :key="item.key">
          <template v-slot:activator>
            <v-list-item-title>{{$t(item.title)}}</v-list-item-title>
          </template>
          <v-list-item
            v-for="subitem in item.subitems"
            :key="`${item.key}/${subitem.key}`"
            :to="subitem.to"
            :href="subitem.href"
            @click="onSubitemClick(item, subitem, $event)"
          >
            <v-list-item-icon v-if="subitem.icon">
              <v-icon>{{subitem.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{$t(subitem.title)}}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  computed: {
    showDrawer: {
      get(){
        return this.$store.state.appbar.drawer.show
      },
      set(v){
        this.$store.commit('appbar/toggleDrawer', v)
      }
    },
    user(){
      return this.$store.state.user.profile
    },
    items(){
      return this.$store.state.appbar.drawer.items
    },
    topMargin(){
      return this.$store.state.topMargin
    },
    autoDisplay(){
      return this.$store.state.autoDisplay
    }
  },
  data(){
    return {
      drawerFixed: false,
      temporary: true,
      permanent: true
    }
  },
  mounted(){
    this.onResize()
    this.$onResize = this.onResize.bind(this)
    this.$bus.$on('window-resize', this.$onResize)
    console.log('test', this.$vuetify, this.$vuetify.breakpoint)
  },
  beforeDestroy () {
    if(window) {
      this.$bus.$off('window-resize', this.$onResize)
    }
  },
  methods: {
    onResize(){
      // this.drawerFixed = this.$vuetify.breakpoint.mdAndUp
      // this.temporary = !this.drawerFixed
      // this.permanent = this.drawerFixed
      if(this.autoDisplay && this.$vuetify.breakpoint.mdAndUp){
        this.$store.commit('appbar/toggleDrawer', true)
      }else{
      }
      // console.log('resize', this.$vuetify.breakpoint.name, this.drawerFixed)
    },
    onItemClick(item, event){
      this.$bus.$emit('drawer-item-click', item, event)
    },
    onSubitemClick(parent, item, event){
      this.$bus.$emit('drawer-item-click', item, event)
    }
  }
}
</script>

<style></style>
